import { inject } from 'vue';

import { SentrySymbol } from '@/configs/sentry';

export default function useSentry() {
  return inject(SentrySymbol);
}
